// Ending a session that nobody ended: the page reloaded, the phone died, or the
// observer signed out mid-session. The block still open is closed at the last
// moment the session was known to be alive, never at whenever the app happens
// to be opened next, which could be the following morning.
//
// Pure, so the times it picks can be tested without a browser.

import { endSession, resumeState } from "./tracker.ts";
import type { LocalSession } from "./queue.ts";

/** The latest moment this phone saw the session alive. */
export function lastKnownAt(s: LocalSession): number {
  let t = Math.max(s.startedAt, s.lastSeenAt ?? 0);
  for (const b of s.pendingBlocks) {
    t = Math.max(t, b.startedAt, b.endedAt ?? 0);
    for (const tap of b.taps) t = Math.max(t, tap.tappedAt);
  }
  for (const n of s.pendingNotes) t = Math.max(t, n.notedAt);
  return t;
}

export function closeAbandoned(s: LocalSession): LocalSession {
  if (s.endedAt !== null) return s;
  const at = lastKnownAt(s);
  const { closed } = endSession(resumeState(s.pendingBlocks, s.nextSeq), at);
  const pendingBlocks = closed
    ? s.pendingBlocks.map((b) => (b.id === closed.id ? closed : b))
    : s.pendingBlocks;
  // The block history exists for the live summary and the end screen, neither
  // of which a session ended from the resume card shows, so it goes here too.
  return { ...s, pendingBlocks, history: undefined, endedAt: Math.max(closed?.endedAt ?? at, s.startedAt) };
}
